<template>
  <div>

    <v-row class="text-center mt-5">

      <v-col cols="12">
        <v-img :src="require('../../assets/logo.png')" class="mt-3 mb-5" height="300" contain />
      </v-col>

      <v-col class="mb-4">
        <h2 class="mb-3 tertiary--text">
          WELCOME TO
        </h2>
        <h1 class="display-3 font-weight-bold mb-4">
          <Title />
        </h1>

        <p class="subheading font-weight-regular tertiary--text">
          WILL SHOW YOU KEYWORDS YOU DIDN'T THINK EXISTED
        </p>
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12" class="text-center d-flex justify-center">
        <v-btn 
          color="secondary" 
          fab x-large dark
          v-if="email" 
          :to="{name: 'app.index'}"
        >
          <v-icon color="primary">mdi-fingerprint</v-icon>
        </v-btn>
        <login-button v-else/>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import Title from '#Components/shared/Title'
import LoginButton from '#Components/auth/LoginButton'
import { mapGetters } from 'vuex'

export default {
  
  components: {
    Title,
    LoginButton
  },

  computed: {
    ...mapGetters('user', ['email', 'name', 'avatar'])
  }
  
}
</script>